<template>
  <Fragment>
    <FormSection :name="$t('orderForm.orderInfo')">
      <StatusInfo :status="value.status" :isInvoiced="value.billing && value.billing.invoice_status == 'invoiced'" />
      <FormInput :name="$t('orderDetail.comment')" :value="value.comment" @input="updateComment" />
    </FormSection>
    <FormSection>
      <StaticInfo :name="$t('orderDetail.createdAt')" :value="formattedFromDateTime(value.created_at)" />
      <StaticInfo :name="$t('orderDetail.lastUpdate')" :value="formattedFromDateTime(value.updated_at)" />
    </FormSection>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

import FormInput from '@/components/Form/Input/index.vue'
import FormSection from '@/components/Form/Section/index.vue'
import StaticInfo from '@/components/Form/StaticInfo/index.vue'
import StatusInfo from '@/components/Orders/forms/sections/elements/StatusInfo.vue'
import dateUtils from '@/components/mixins/dateUtils'

export default {
  name: 'InfoSection',
  components: {
    FormInput,
    FormSection,
    Fragment,
    StaticInfo,
    StatusInfo,
  },
  mixins: [dateUtils],
  props: {
    value: { type: Object, required: true },
  },
  methods: {
    updateComment(comment) {
      this.$emit('input', { ...this.value, comment })
    },
  },
}
</script>
